import styled from 'styled-components';

export const FooterContainer = styled.footer`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  height: 3.5rem;
  width: 100%;
  background: linear-gradient(
    92deg,
    ${({ theme }) => theme.colors.secondary} 0%,
    ${({ theme }) => theme.colors.primary} 100%
  );

  span {
    color: ${({ theme }) => theme.colors.background_white};
  }

  .version {
    padding: 0.5rem 0.5rem 0 0;
    display: flex;
    flex-direction: column;
  }
`;
